<template>
    <div class="search-result-item ul-wide-border-panel mb-3">
        <div class="d-flex pt-2 pb-2 item-info-div">
            <div class="flex-grow-0 d-flex flex-column align-items-center justify-content-center pl-2 pr-2">
                <img class="part-image" v-bind:src="partImageSrc(searchItem.part_image_url)">
                <a class="part-image-credit" target="_blank" rel="nofollow" v-bind:href="searchItem.part_image_credit_url">{{searchItem.part_image_credit_name}}</a>
            </div>
            <div class="flex-grow-1 d-flex flex-row flex-wrap search-result-content">
                <div class="d-flex flex-grow-1 flex-column align-items-center justify-content-center search-result-item-mfr-heading">
                    <div class="text-center">{{searchItem.mfr_name}}</div>
                    <a class="part-link" rel="nofollow" v-on:click.prevent="selectPart(searchItem.part_uuid)" href="#">
                        {{searchItem.part_number}}
                    </a>
                </div>
                <div class="d-flex flex-grow-1 search-result-item-description small m-2" v-bind:class="{'react-hidden' : searchItem.description === null }">
                    <div class="text-center">
                        {{searchItem.description}}
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2 search-result-item-border ">
                <div>Models Available</div>
                <div class="d-flex model-availability-listing">
                    <div v-bind:class="[searchItem.symbol_available ? 'model-availability-symbol-active' : 'model-availability-symbol-inactive']"></div>
                    <div v-bind:class="[searchItem.footprint_available ? 'model-availability-footprint-active' : 'model-availability-footprint-inactive']"></div>
                    <div v-bind:class="[searchItem.threed_available ? 'model-availability-threed-active' : 'model-availability-threed-inactive']"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SearchLine',
        props: {
            searchItem: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        methods: {
            selectPart(partUUID) {
                this.$root.$emit('select_part', partUUID);
            },
            partImageSrc(imgSrc) {
                if (imgSrc != undefined && imgSrc != null && imgSrc != '')
                    return imgSrc;
                return require('../assets/images/placeholders/Image-Unavailable.png');
            }
        }
    }
</script>

<style>
    .model-availability-symbol-active {
        background-image: url('../assets/images/symbols/SymbolYes.svg');
    }

    .model-availability-footprint-active {
        background-image: url('../assets/images/symbols/FootprintYes.svg');
    }

    .model-availability-threed-active {
        background-image: url('../assets/images/symbols/3DYes.svg');
    }

    .model-availability-symbol-inactive {
        background-image: url('../assets/images/symbols/SymbolNo.svg');
    }

    .model-availability-footprint-inactive {
        background-image: url('../assets/images/symbols/FootprintNo.svg');
    }

    .model-availability-threed-inactive {
        background-image: url('../assets/images/symbols/3DNo.svg');
    }

    .search-result-item-description {
        max-width: 540px;
        height: 40px;
        overflow: hidden;
        -ms-word-break: break-all;
        word-break: break-all;
        word-break: break-word;
        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
        width: 100% !important;
    }

    @media (max-width: 1299.9px) {

        .search-result-item-description {
            height: 32px;
        }

        .model-availability-listing div {
            height: 18px;
            width: 30px;
            margin: 2px 3px 1px 3px;
            display: inline-block;
        }

        .search-result-content {
            column-count: 1;
        }

        div.react-hidden {
            display: none !important;
        }

    }

    @media (min-width: 1300px) {

        .model-availability-listing div {
            height: 25px;
            width: 38px;
            margin: 4px 6px 2px 6px;
            display: inline-block;
        }

        .search-result-content {
            column-count: 2;
        }

    }
</style>